import { useNavigate, useSearch } from '@tanstack/react-location'
import ScreenLayout from 'MediaManager/layouts/ScreenLayout'
import { getManageProperties } from 'MediaManager/services/property'
import React, { useCallback, useMemo } from 'react'
import Loader from 'shared/components/Loader'
import Select from 'shared/components/Select'
import { smartSort } from 'shared/helpers/arrays'
import { objectCopy } from 'shared/helpers/general'
import { useRequest } from 'shared/hooks/useRequest'
import LivingLinks from './components/LivingLinks'

function LivingDashboardScreen(props) {
  const { property_id } = useSearch()
  const getManagePropertiesRequest = useCallback(async () => {
    const { data } = await getManageProperties()
    return data.properties
  }, [])

  const { data: properties, loading } = useRequest(getManagePropertiesRequest)

  const propertiesOptions = useMemo(() => {
    return objectCopy(properties || [])
      .sort(smartSort('property_name'))
      .map(({ id, property_name }) => ({ value: id, label: property_name }))
  }, [properties])

  const navigate = useNavigate()

  const property = useMemo(() => {
    if (properties) {
      return properties.find((property) => property.id === property_id)
    }
  }, [property_id, properties])

  return (
    <ScreenLayout title="Living dashboard">
      {loading && (
        <div>
          <Loader />
        </div>
      )}
      {!loading && (
        <div>
          <Select
            onChange={(val) => navigate({ to: `/living/dashboard?property_id=${val.value}` })}
            value={propertiesOptions.find((property) => property.value === property_id) || ''}
            options={propertiesOptions}
            placeholder="Property name"
          />
        </div>
      )}
      {property && <LivingLinks property={property} />}
    </ScreenLayout>
  )
}

export default LivingDashboardScreen
